export const WHATSAPP_SESSION_BLOCKED_MSG =
  "Cannot send a free-form WhatsApp message because the customer's last message was more than 24 hours ago. Use a WhatsApp template to contact them outside the 24-hour window.";
